<template>
  <div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-cfs"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new cfs</small
                >
              </legend>
              <form @submit.prevent="newCfs()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>cfs name</label>
                      <input
                        type="text"
                        class="form-control cfs_name"
                        placeholder="cfs /location name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingCfs"
                >
                  <i class="fa fa-plus"></i> Add cfs
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingCfsLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal animated fadeIn"
      tabindex="-1"
      id="new-consignee"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold"
                  >new consignee</small
                >
              </legend>
              <form @submit.prevent="newConsignee()">
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Consignee name</label>
                      <input
                        type="text"
                        class="form-control consignee_name"
                        placeholder="consignee name"
                        required
                      />
                    </div>
                  </div>
                </div>
                <button
                  type="submit"
                  class="btn btn-primary btn-flat creatingConsignee"
                >
                  <i class="fa fa-plus"></i> Add consignee
                </button>
                <button
                  type="button"
                  class="btn btn-primary btn-flat creatingConsigneeLoader"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <i class="fa fa-spinner fa-spin" style="font-size: 24px"></i>
                  please wait...
                </button>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New trip for {{ Truck.truck_no }}</div>
            <fieldset class="border p-2">
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-cfs"
              >
                <i class="fa fa-plus"></i> New cfs
              </button>
              <p></p>
              <button
                type="button"
                class="btn btn-primary btn-roundec"
                data-toggle="modal"
                data-target="#new-consignee"
              >
                <i class="fa fa-plus"></i> New consignee
              </button>
              <p></p>
              <div>
                <form @submit.prevent="newTrip()">
                  <div class="row">
                    <input type="hidden" class="truck_id" :value="Truck.id" />
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Loading date</label>
                        <input
                          type="date"
                          class="form-control loading_date"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Consignee</label>
                        <select
                          class="form-control consignee_id js-example-basic-single"
                          required
                        >
                          <option>select consignee</option>
                          <option
                            v-for="consignee in systemConsignees"
                            :value="consignee.id"
                            :key="consignee.id"
                          >
                            {{ consignee.consignee_name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>Cfs</label>
                        <select
                          class="form-control cfs_id js-example-basic-single"
                          required
                        >
                          <option value>select cfs</option>
                          <option
                            v-for="cfs in systemCfss"
                            :value="cfs.id"
                            :key="cfs.id"
                          >
                            {{ cfs.cfs_name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Trip charges</label>
                        <input
                          type="number"
                          min="1"
                          step="0.01"
                          class="form-control trip_charge"
                          @wheel="$event.target.blur()"
                          required
                        />
                      </div>
                      <div class="form-group">
                        <label>Container no</label>
                        <input
                          type="text"
                          class="form-control container_no"
                          placeholder="Container_no"
                        />
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    class="btn btn-primary btn-flat creatingTrip btn-rounded"
                  >
                    <i class="fa fa-plus"></i> create trip
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary btn-flat creatingTripLoader btn-rounded"
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <i
                      class="fa fa-spinner fa-spin"
                      style="font-size: 24px"
                    ></i>
                    please wait...
                  </button>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import router from "../router/index";
import { ModelListSelect } from "vue-search-select";
import $ from "jquery";
export default {
  created() {
    if (this.$store.getters.Truck.length === 0) {
      router.push("/newtrip");
    }
    this.loadCfs();
    this.loadConsignees();
  },

  computed: {
    ...mapGetters(["systemCfss", "systemConsignees", "Truck"]),
  },

  methods: {
    ...mapActions([
      "loadCfs",
      "newCfs",
      "newConsignee",
      "newTrip",
      "loadConsignees",
    ]),
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingCfsLoader {
  display: none;
}
.creatingTripLoader {
  display: none;
}
.creatingConsigneeLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/trips/addtrip.vue